import { format } from 'date-fns';
import ICashFlow from '~/interfaces/ICashFlow';
import ICompany from '~/interfaces/ICompany';
import IOrder from '~/interfaces/IOrder';

interface ProcessCashFlowProps {
  company: ICompany;
  launchs: ICashFlow[];
  orders: IOrder[];
}

export function processCashFlow({
  company,
  launchs,
  orders,
}: ProcessCashFlowProps) {
  const openedAt = launchs.find(item => item.type === '100');

  if (!openedAt) {
    throw new Error('Atenção! O caixa não foi aberto.');
  }

  const openedAtDate = format(
    new Date((openedAt.date as any).seconds * 1000),
    'dd/MM/yyyy HH:mm',
  );

  const closedAt = launchs.find(item => item.type === '99');

  // if (!closedAt) {
  //   throw new Error('Atenção! O caixa não foi fechado.');
  // }

  const closedAtDate = closedAt
    ? format(
        new Date((closedAt.date as any).seconds * 1000),
        'dd/MM/yyyy HH:mm',
      )
    : format(new Date(), 'dd/MM/yyyy HH:mm');

  let suppliesBalance = 0;
  let sangriaBalance = 0;

  launchs.forEach(item => {
    if (item.type === '1') suppliesBalance += item.value;
    if (item.type === '0') sangriaBalance += item.value;
  });

  const resumeSales = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    ifoodBalance: 0,
    total: 0,
  };

  const resumeSalesDelivery = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    ifoodBalance: 0,
    taxBalance: 0,
    valueProducts: 0,
    total: 0,
  };

  const resumeSalesLocal = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  const resumeSalesTable = {
    moneyBalance: 0,
    pixBalance: 0,
    creditBalance: 0,
    debitBalance: 0,
    total: 0,
  };

  orders.forEach(item => {
    // retirada local
    if (
      item.order_type === '0' &&
      !item.table &&
      !item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesLocal.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesLocal.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesLocal.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesLocal.pixBalance += item.total;

      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSalesLocal.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSalesLocal.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSalesLocal.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSalesLocal.pixBalance += item.total;
      });
    }

    // mesas
    if (
      item.order_type === '2' ||
      item.table ||
      item.name.toLowerCase().includes('mesa')
    ) {
      if (item.paymentMethod === '0')
        resumeSalesTable.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesTable.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesTable.creditBalance += item.total;
      if (item.paymentMethod === '3') resumeSalesTable.pixBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesTable.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesTable.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesTable.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesTable.pixBalance += item.total;
        });
      }
    }

    // delivery
    if (item.order_type === '1') {
      resumeSalesDelivery.taxBalance += item.shippingCost;

      if (item.paymentMethod === '0')
        resumeSalesDelivery.moneyBalance += item.total;
      if (item.paymentMethod === '1')
        resumeSalesDelivery.debitBalance += item.total;
      if (item.paymentMethod === '2')
        resumeSalesDelivery.creditBalance += item.total;
      if (item.paymentMethod === '3')
        resumeSalesDelivery.pixBalance += item.total;
      if (item.paymentMethod === '5')
        resumeSalesDelivery.ifoodBalance += item.total;

      if (item.orderPayments) {
        item.orderPayments.forEach(payment => {
          if (payment.payment_method_id === '0')
            resumeSalesDelivery.moneyBalance += item.total;
          if (payment.payment_method_id === '1')
            resumeSalesDelivery.debitBalance += item.total;
          if (payment.payment_method_id === '2')
            resumeSalesDelivery.creditBalance += item.total;
          if (payment.payment_method_id === '3')
            resumeSalesDelivery.pixBalance += item.total;
          if (payment.payment_method_id === '5')
            resumeSalesDelivery.ifoodBalance += item.total;
        });
      }
    }

    if (item.paymentMethod === '0') resumeSales.moneyBalance += item.total;
    if (item.paymentMethod === '1') resumeSales.debitBalance += item.total;
    if (item.paymentMethod === '2') resumeSales.creditBalance += item.total;
    if (item.paymentMethod === '3') resumeSales.pixBalance += item.total;
    if (item.paymentMethod === '5') resumeSales.ifoodBalance += item.total;

    if (item.orderPayments) {
      item.orderPayments.forEach(payment => {
        if (payment.payment_method_id === '0')
          resumeSales.moneyBalance += item.total;
        if (payment.payment_method_id === '1')
          resumeSales.debitBalance += item.total;
        if (payment.payment_method_id === '2')
          resumeSales.creditBalance += item.total;
        if (payment.payment_method_id === '3')
          resumeSales.pixBalance += item.total;
        if (payment.payment_method_id === '5')
          resumeSales.ifoodBalance += item.total;
      });
    }
  });

  const valueInCash =
    openedAt.value +
    suppliesBalance -
    sangriaBalance +
    resumeSales.moneyBalance;

  resumeSales.total =
    resumeSales.moneyBalance +
    resumeSales.pixBalance +
    resumeSales.creditBalance +
    resumeSales.debitBalance +
    resumeSales.ifoodBalance;

  resumeSalesDelivery.total =
    resumeSalesDelivery.moneyBalance +
    resumeSalesDelivery.pixBalance +
    resumeSalesDelivery.creditBalance +
    resumeSalesDelivery.debitBalance +
    resumeSalesDelivery.ifoodBalance;

  resumeSalesDelivery.valueProducts =
    resumeSalesDelivery.total - resumeSalesDelivery.taxBalance;

  resumeSalesLocal.total =
    resumeSalesLocal.moneyBalance +
    resumeSalesLocal.pixBalance +
    resumeSalesLocal.creditBalance +
    resumeSalesLocal.debitBalance;

  resumeSalesTable.total =
    resumeSalesTable.moneyBalance +
    resumeSalesTable.pixBalance +
    resumeSalesTable.creditBalance +
    resumeSalesTable.debitBalance;

  return {
    printType: 'cashflow',
    company,
    openedAtDate,
    openedAt,
    closedAtDate,
    suppliesBalance,
    sangriaBalance,
    valueInCash,
    resumeSales,
    resumeSalesDelivery,
    resumeSalesLocal,
    resumeSalesTable,
  };
}
